import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.43 7.386c-.812-3.77-2.542-6.154-4.143-6.154S8.956 3.617 8.145 7.386zM7.672 12c0 1.028.069 2.056.205 3.076h8.82a23 23 0 0 0 0-6.153h-8.82a23 23 0 0 0-.205 3.076Zm.473 4.615c.81 3.77 2.542 6.154 4.142 6.154s3.331-2.385 4.143-6.154zm9.86-9.23h4.845A11.58 11.58 0 0 0 14.813.75c1.46 1.284 2.604 3.657 3.191 6.635Zm5.396 1.538h-5.153a25 25 0 0 1 0 6.153H23.4c.56-2.013.56-4.14 0-6.153ZM14.813 23.25a11.58 11.58 0 0 0 8.04-6.635h-4.847c-.589 2.978-1.733 5.352-3.192 6.635Zm-8.244-6.635H1.723A11.58 11.58 0 0 0 9.76 23.25c-1.46-1.284-2.605-3.657-3.192-6.634ZM9.76.75a11.58 11.58 0 0 0-8.038 6.635h4.845C7.157 4.407 8.301 2.034 9.76.75M6.133 12q0-1.546.191-3.077H1.171a11.46 11.46 0 0 0 0 6.153h5.153a25 25 0 0 1-.19-3.077Z"
    }, null, -1)
  ]))]))
}
export default { render: render }